import { observer } from 'mobx-react';
import { T } from '../../../../Translations';

function SkipInvitation() {
  return (
    <p className="mt-4 text-sm">
      <T kind="Participants will gain immediate access and no email will be sent to the invited participants." />
    </p>
  );
}

export default observer(SkipInvitation);
